import Orders from '@/pages/Orders'

export default {
  path: '/orders/',
  name: 'Orders',
  component: Orders
}



// WEBPACK FOOTER //
// ./src/router/orders.js